import React, { useState } from 'react';

import LandingHeading from 'common/www/LandingV3/LandingHeading';
import LandingTabCards from 'common/www/LandingV3/LandingTabs/LandingTabCards';
import styles from 'css-module/components/www/LandingTabs/_LandingTabs.module.scss';

import type { LinkTab as Tab } from 'common/www/LandingV3/LandingTabs';

type Copy = {
  title: string;
  subtitle: string;
};

export type Props = {
  copy: Copy;
  tabs: Tab[];
  defaultActiveTab?: number;
};

const LandingTabsAsLinks = ({ copy, tabs, defaultActiveTab }: Props) => {
  const [currentTabIndex, setTabIndex] = useState(defaultActiveTab);
  return (
    <section className={styles.container}>
      <LandingHeading {...copy} center className={styles.heading} />
      <LandingTabCards tabs={tabs} currentTabIndex={currentTabIndex} setTabIndex={setTabIndex} />
    </section>
  );
};

export default LandingTabsAsLinks;
